import styled from "styled-components";
import { IThemeProvider } from "../../Theme/defaultTheme";

export const ProfileBlockItem = styled.div<IThemeProvider>`
  padding: 0;
  margin: 0;

  display: flex;
  align-items: center;
`;

export const InputButtonContainer = styled.div`
  position: relative;
  display: flex;
  gap: 10px;
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const LinkWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  font-size: var(--font-size-content);

  a {
    color: var(--color-brand-blue);
    text-decoration: none;

    &:hover {
      color: var(--color-brand-hover);
    }
  }
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
`;

export const GeneratePopupBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
  text-align: center;

  span {
    margin: 0 auto;
  }

  p {
    font-size: var(--font-size-content);
  }

  button {
    margin: 5px auto 0;
  }
`;
